var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-service-btn",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"customer-service-img",attrs:{"src":require("@/assets/img/chargingVoucher/icon-customer-service.png")}}),(_vm.$parent.$parent.showBottomNavBar)?_c('div',{staticClass:"h-bottom-nav"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }